import styled from 'styled-components';
import * as theme from '@zero/design-tokens/build/js/variables';
import DesignTokens from 'uol-host-react-ui/dist/shared/DesignTokens.styles';

export const  TermsOfAcceptanceContent = styled.div`
    display: inline-flex;
    width: 100%;
    
    input {
        position: relative;
        top: 2px;
        margin: 0;
        margin-right: 4px;
        word-wrap: break-word;
    }

    span {
        word-wrap: break-word;
        white-space: normal;
    }
    
    label {
        padding:0;        
        font-size: ${theme.ZrFontSizeMicro};
        color: ${theme.ZrColorNeutralMedium03};
    }

    a:visited {
        color: ${DesignTokens.color.link}!important;
    }
`
